<div
  class="w-full flex items-center"
  [ngClass]="{
    'flex-col': position === 'col',
    'flex-row-reverse justify-center': position === 'inline',
  }"
>
  <div
    class="flex items-center justify-center"
    [ngClass]="{
      'w-full  mb-2': position === 'col',
      'ml-2': position === 'inline',
    }"
  >
    @if (spinner) {
      <confect-spinner [show]="true" class="mr-1" />
    }
    <div class="flex items-center justify-center">{{ progressMessage }}</div>
  </div>

  @if (progressMode === "determinate") {
    <div
      class="h-1 rounded-full overflow-hidden bg-gray-100"
      [ngClass]="{
        'w-full': position === 'col',
        'flex flex-grow': position === 'inline',
      }"
    >
      <div
        class="h-full transition-all duration-200"
        [ngClass]="{
          'bg-primary': progressValue <= 100,
          'bg-red': progressValue > 100,
        }"
        [style.width.%]="progressValue"
      ></div>
    </div>
  }
</div>
